<template>
        <div>
          <!-- 头部 -->
          <Header title="linyuan"></Header>
          <Banner :bgImg="bannerImg" :title="'linyuan'"></Banner>
          <div class="tianqBox">
              <p class="lyTitle">{{$t('linyuan.p1')}}</p>
             <!-- 引擎 -->
             <div class="indexYq bannerW" style="padding-top: 122px;">
                <div class="yqBox wow slideInUp">
                  <div class="left">
                    <p :class="['yqName',lang=='en'?'wd448 font40':'wd360 font60']">{{$t('linyuan.summary.tit1')}}</p>
                    <p :class="['yqDscp',lang=='en'?'wd448':'wd363']">{{$t('linyuan.summary.tips1[0]')}}</p>
                  </div>
                  <div class="right">
                    <img src="@/assets/images/linyuan1.png" alt="">
                  </div>
                </div>
                <div class="yqBox wow slideInUp">
                  <div class="right">
                    <img src="@/assets/images/linyuan2.png" alt="">
                  </div>
                  <div class="left" >
                    <p :class="['yqName',lang=='en'?'wd448 font40':'wd360 font60']">{{$t('linyuan.summary.tit2')}}</p>
                    <p :class="['yqDscp',lang=='en'?'wd448':'wd360']">{{$t('linyuan.summary.tips2[0]')}}</p>
                  </div>
                </div>
                <div class="yqBox wow slideInUp">
                    <div class="left">
                        <p :class="['yqName',lang=='en'?'wd448 font40':'wd360 font60']">{{$t('linyuan.summary.tit3')}}</p>
                        <p :class="['yqDscp',lang=='en'?'wd448':'wd363']">{{$t('linyuan.summary.tips3[0]')}}</p>
                    </div>
                    <div class="right">
                        <img src="@/assets/images/linyuan3.png" alt="">
                    </div>
                </div>
              </div>
          </div>
          <!-- 介绍：一站式介入 -->
          <div class="tqDesc mt50">
            <div class="bannerW">
              <ul>
                <li v-for="(key,index) in $t('tianqin.desc')" :key = "index">
                  <div class="imgDesc">
                    <img :src="tqDescImg[index]" alt="">
                  </div>
                  <div class="imgText">
                    <p :class="'name name'+index">{{key.n}}</p>
                    <p :class="'desc desc'+index">{{key.d}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 尾部 -->
          <Footer></Footer>
        </div>
      </template>
      
      <script>
        import Header from "../../components/header.vue";
        import Footer from "../../components/footer.vue";
        import silder1 from "@/assets/images/slider.png";
        import Banner from "../../components/banner.vue";
        import bannerImg from  "@/assets/images/bg3.png"
        import prj1 from "@/assets/images/arrow-w@2x.png";
        import b1 from "@/assets/images/b1.png";
        import b2 from "@/assets/images/b2.png";
        import b3 from "@/assets/images/b3.png";
        import b4 from "@/assets/images/b4.png";
    
        export default {
          name: "linyuan",
          components: {
            Header,
            Footer,
            Banner,
          },
          data(){
            return{
              lang: this.$i18n.locale,
              tqDescImg:[b1,b2,b3,b4],
              bannerImg:bannerImg,
              projectList:[{
                projectName:"天琴",
                projectType:"PC/H5广告平台",
                img:prj1,
              },{
                projectName:"天琴",
                projectType:"PC/H5广告平台",
                img:prj1,
              },{
                projectName:"天琴",
                projectType:"/H5广告平台",
                img:prj1,
              }],
              listImg:[
                {
                  adr:"javascript:;",
                  image:silder1
                },
                {
                  adr:"javascript:;",
                  image:silder1
                },
                {
                  adr:"javascript:;",
                  image:silder1
                }
              ]
            }
          }
        };
      </script>
      <style lang="scss" scoped>
          .lyTitle{
            width:891px;
            height:80px;
            font-size:16px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(80,80,80,1);
            line-height:40px;
            text-align: center;
            margin:89px auto 0 auto;
          }
        /* @import url("../assets/css/common.scss"); */
        @import url("https://fonts.googleapis.com/css?family=Work+Sans:400,700,900");
        $anim-text-offset: 1em;
        .tqDesc{
          width:100%;
          height:170px;
          background:rgba(251,251,251,1);
          .bannerW{
            height:100%;
            display:flex;
            flex-direction:row;
            align-items: center;

          }
          ul{
            width:100%;
            display:flex;
            flex-direction:row;
            justify-content:space-between;
            li{
              display:flex;
              flex-direction:row;
              align-items:flex-start;
              .imgDesc{
                  width: 66px;
                  height:66px;
              }
              .imgText{
                margin-left: 15px;
                .name{
                  font-size:20px;
                  font-family:PingFangSC-Semibold,PingFang SC;
                  font-weight:600;
                  color:rgba(34,34,34,1);
                }
                .name2{
                  width: 210px;
                }
                .desc{
                  font-size:16px;
                  font-family:PingFangSC-Regular,PingFang SC;
                  font-weight:400;
                  color:rgba(153,153,153,1);
                  margin-top:15px;
                }
                .desc0{
                  width: 200px;
                }
                .desc2{
                  width: 223px;
                }
                .desc3{
                  width: 146px;
                }
              }
            }
          }
        }
        
      </style>